import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { getNewsById } from "../../app/api";
import { useNavigate, useParams } from "react-router-dom";
import NewsSlider from "./news-slider";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";

const HTMLTextView = ({ htmlContent }: any) => {
  return (
    <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
  );
};

const settings = {
  dots: true,
  arrows: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
};

export enum NewsType {

  image = "Зураг",
  video = "Бичлэг",
  reminder = "Санамж",
  notice = "Зарлал",

}


export interface INews {
  title: string;
  subtitle: string;
  content: string;
  thumb: string;
  images: [string];
  type: NewsType;
  videoUrl: string;
  createAdmin: string;
  updateAdmin: string;
  status: boolean;
}

export default function NewsDetail() {
  const [loading, setLoading] = useState(false);
  const [news, setNews] = useState<INews>({} as INews);
  const [images, setImages] = useState<any>([]);

  const params = useParams();

  useEffect(() => {
    setLoading(true);
    try {
      getNewsById(params.id).then((res) => {
        setNews(res.data);
        setImages(res.data.images.map((image: any) => {
          return {
            original: image,
            thumbnail: image,
          };
        }));
      });
    } catch (err) {
    }
    setLoading(false);
    window.document.body.scrollTop = 0;
    window.document.documentElement.scrollTop = 0;
  }, [params.id]);

  return (
    <>
      <div className="bg-white py-32">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          {loading &&
            <div className="w-full h-full fixed top-0 left-0 bg-white opacity-75 z-50">
              <div className="flex justify-center items-center mt-[50vh]">
                <div role="status" className="absolute -translate-x-1/2 -translate-y-1/2 top-2/4 left-1/2">
                  <svg aria-hidden="true" className="w-24 h-24 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" /><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" /></svg>
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          }
          <div className="mx-auto grid max-w-2xl grid-cols-1 items-start gap-x-8 gap-y-16 sm:gap-y-24 lg:mx-0 lg:max-w-none lg:grid-cols-2">
            <div className="lg:pr-4 mt-4">
              {news.videoUrl ? (
                <iframe
                  src={`https://www.youtube.com/embed/${news.videoUrl.split("v=")[1].split("&")[0]}`}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  title="Video"
                  className="h-[200px] md:h-[400px] w-full object-cover object-center sm:rounded-lg"
                />
              ) : (
                <img
                  className="h-[200px] md:h-[400px] w-full object-cover"
                  src={news.thumb}
                  alt="image"
                />
              )}


            </div>
            <div>
              <div className="text-base leading-7 text-gray-700 lg:max-w-lg">
                <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-2xl">
                  {news.title}
                </h1>
                <div className="max-w-xl">
                  <HTMLTextView htmlContent={news.content} />
                </div>


              </div>
            </div>

            {news.images && news.images.length > 0 &&
              <div className="w-[600px] h-[400px]">
                <ImageGallery items={images} />
              </div>
            }



          </div>
        </div>
      </div>

      <div className="bg-white py-24 sm:py-32">


        <NewsSlider />
        {/* <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="mx-auto max-w-2xl text-center">
            <h2 className="text-3xl font-bold tracking-tight text-[#003463] sm:text-4xl italic">
              Мэдээ, мэдээлэл
            </h2>
          </div>
          <div className="flex overflow-x-scroll pb-10 scrollbar-hide ">
            <div className="mx-auto mt-16 max-w-2xl lg:mx-0 lg:max-w-none cursor-pointer flex flex-nowrap">
              {Data.filter((item) => item.id !== Number(params.id)).map(
                (post) => (
                  <div
                    onClick={() => router.push(`/news/${post.id}`)}
                    key={post.id}
                    className="w-80 h-auto items-start justify-between inline-block px-3"
                  >
                    <div className="w-72">
                      <div className="relative w-full">
                        <img
                          src={post.image}
                          alt=""
                          className="aspect-[16/9] w-full rounded-2xl bg-gray-100 object-cover sm:aspect-[2/1] lg:aspect-[3/2]"
                        />
                        <div className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-gray-900/10" />
                      </div>
                      <div className="max-w-xl">
                        <div className="group relative">
                          <h3 className="mt-3 text-lg font-semibold leading-6 text-[#003463] ">
                            {post.title}
                          </h3>
                          <p className="mt-5 line-clamp-4 text-sm leading-6 text-[#001447]">
                            {post.content}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              )}
            </div>
          </div>
        </div> */}
      </div>
    </>
  );
}
